import Session from 'ember-simple-auth/services/session';

export default class SessionService extends Session {
  handleAuthentication(routeAfterAuthentication: string) {
    // Do nothing.  If super.handleAuthentication is called, it will redirect
    // to the login route, which is not what we want.
  }
}
